document.addEventListener("DOMContentLoaded", function() {
    // Optional debug toggle
    const DEBUG = true;

    // Flatten all arrays from each Leaflet Maps Section
    const mergedBlocks = (window.allMapBlocks || []).flat();
    let allLocations = [];
    let geocodeQueue = [];

    // Convert each block into lat/lng data
    mergedBlocks.forEach(block => {
        const lat = parseFloat(block.settings.latitude) || 0;
        const lng = parseFloat(block.settings.longitude) || 0;
        const address = [
        block.settings.store_address + ' ' + block.settings.store_city.trim(),
        ].join(', ');

        const locationData = {
            title: block.settings.title || '',
            lat: lat,
            lng: lng,
            description: address
        };

        //console.log('Location to insert: ', locationData);

        if (!lat || !lng) {
            geocodeQueue.push({ locationData, address });
        } else {
            console.log('Lat lng for address: ',address);
            allLocations.push(locationData);
        }

    });

    // -----------------------------------------------
    // 1) HELPER FUNCTIONS: USER LOCATION, DISTANCE
    // -----------------------------------------------

    // Get user location (sessionStorage caching)
    function getUserLocation() {
        var storageKey = "cc-location";
        return new Promise(function (resolve, reject) {
        var storedCoords;
        if (sessionStorage[storageKey]) {
            storedCoords = JSON.parse(sessionStorage[storageKey]);
        }
        if (storedCoords) {
            resolve(storedCoords);
        } else {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        var lng = position.coords.longitude;
                        var lat = position.coords.latitude;
                        var coords = { latitude: lat, longitude: lng };

                        // Optionally update Shopify's localization
                        fetch("/localization.json", {
                            method: "PUT",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(coords),
                        });

                        sessionStorage[storageKey] = JSON.stringify(coords);
                        resolve(coords);
                    },
                    function () {
                        resolve(false);
                    },
                    { maximumAge: 3600000, timeout: 5000 }
                );
            } else {
                resolve(false);
            }
        }
        });
    }

    // Haversine distance
    function calculateDistance(coords1, coords2, unitSystem) {
        var dtor = Math.PI / 180;
        var radius = (unitSystem === "metric") ? 6378.14 : 3959; 
        var rlat1 = coords1.latitude * dtor;
        var rlong1 = coords1.longitude * dtor;
        var rlat2 = coords2.latitude * dtor;
        var rlong2 = coords2.longitude * dtor;
        var dlon = rlong1 - rlong2;
        var dlat = rlat1 - rlat2;
        var a = Math.pow(Math.sin(dlat / 2), 2) +
                Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return radius * c;
    }

    // Update store items’ distances (assuming .store-locator-maplist-item in HTML)
    function updateLocationDistances(userCoords, storeCoords, storeTitle) {
        console.log("[INFO] updateLocationDistances:", userCoords);
        console.log("[INFO] Store list title:", storeTitle);
        
        const mapItemsList = document.querySelectorAll('.store-locator-maplist-item[data-distance="false"]');
        const mapListItem = document.querySelector('.store-locator-maplist-item[data-title="'+storeTitle+'"]');
        
        console.log('___Map list Item___');
        console.log(mapListItem);
        mapItemsList.forEach(function(listItem) {
            let thisCoords;
    
            if (listItem.hasAttribute('data-latitude') && listItem.hasAttribute('data-longitude')) {
                thisCoords = {
                    latitude: parseFloat(listItem.getAttribute("data-latitude")),
                    longitude: parseFloat(listItem.getAttribute("data-longitude"))
                };
            } else {
                thisCoords = storeCoords; 
            }
    
            console.log('________Update location Distance________');
            console.log('User coords:', userCoords);
            console.log('Store coords:', thisCoords);
    
            if (userCoords && thisCoords.latitude && thisCoords.longitude) {
                let distance = calculateDistance(userCoords, thisCoords, "metric").toFixed(1);
                
                let spanElement = listItem.querySelector('p span');
                if (spanElement) {
                    spanElement.textContent = distance;
                }
    
                let paragraphElement = listItem.querySelector('p');
                if (paragraphElement) {
                    paragraphElement.append(" km");
                }
            }
    
            listItem.setAttribute("data-distance", "true");
        });
    }
    

    

    // -----------------------------------------------
    // 2) INIT LEAFLET MAP
    // -----------------------------------------------
    initLeafletMap(allLocations, geocodeQueue);
 
    function initLeafletMap(allLocations, geocodeQueue) {
        const defaultCoords = [55.6761, 12.5683];
        let l = 0;
        const initialCoords = allLocations.length 
          ? [allLocations[0].lat, allLocations[0].lng] 
          : defaultCoords;
        const mapListItemList = document.querySelectorAll('.store-locator-maplist-item');
        const numberOfStores = mapListItemList.length;
        const mapBannerNumber = document.querySelector('.store-locator-maplist-count');
        if(mapBannerNumber){
            mapBannerNumber.textContent = numberOfStores;
        }
        console.log('Number of stores: ', numberOfStores);
        /*
          const firstStoreLat = document.querySelector('.');
          const firstStoreLng = document.querySelector('');
          const firstStoreCoords = [];
        */
       
        // Example: default zoom
        let initialZoom = 7;
    
        // Create map
        //let  map = L.map('map').setView(initialCoords, initialZoom);
        let  map = L.map('map');

        /*map = L.map('map').setView(initialCoords, initialZoom);*/
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
    
        // Add Zoom controls
        // L.control.zoom({
        //     position: 'bottomright'
        //   }).addTo(map);

        // Add serch functionality
        var controlSearch = new L.Control.Search({
            url: 'https://nominatim.openstreetmap.org/search?email=youremail@gmail.com&countrycodes=dk&format=json&q={s}',
            jsonpParam: 'json_callback',
            propertyName: 'display_name',
            propertyLoc: ['lat','lon'],
            container: 'store-locator-searchbox-container',
            position:'topleft',
            zoom: '14',
            minLength: 2,
            initial: false,
            collapsed: false,
            autoResize: false,
            textPlaceholder: '',
            textErr: 'Cancel'
        });
        //map.addControl( controlSearch );

        // Custom pin - Pin is set in theme file
        var mapIcon = L.icon({
            iconUrl: mapIconUrl,
            iconSize:     [38, 40], // size of the icon
            iconAnchor:   [22, 30], // point of the icon which will correspond to marker's location
            popupAnchor:  [-3, -40] // point from which the popup should open relative to the iconAnchor
        });
         
        // Add markers for known lat/lng
        function addMarkers(locations) {
            console.log('[INFO] - Adding markers for location: ', locations);
            //.on('click', onClickMarker)
            
            locations.forEach((loc, index) => {
                const storeCoords = [loc.lat, loc.lng]
                const locationTitle = loc.title;
                // Get user location -> update distances -> sort
                getUserLocation().then(coords => {
                    console.log('User lat, lng: ', coords);
                    if (coords) {
                        userCoord = [coords.latitude, coords.longitude]
                        //map.setView(userCoord, initialZoom);
                        updateLocationDistances(userCoord, storeCoords,locationTitle);
                    }else{
                        map.setView(initialCoords, initialZoom);
                    }
                });

                L.marker([loc.lat, loc.lng], {icon: mapIcon}, {title: 'test'})
                .addTo(map)
                .bindPopup(`<h3>${loc.title}</h3><p>${loc.description}</p>`);

                

            });
        }
        console.log('All locations Before add marker');
        addMarkers(allLocations);

        // Geocode missing lat/lng
        function geocodeNext() {
          if (geocodeQueue.length === 0) return;
          const { locationData, address } = geocodeQueue.shift();
          const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`;
    
          console.log('[INFO] Adding address: ',address);
          fetch(url)
            .then(res => res.json())
            .then(data => {
                if (data.length > 0) {
                    console.log('address data: ', data);
                    locationData.lat = parseFloat(data[0].lat);
                    locationData.lng = parseFloat(data[0].lon);
                    addMarkers([locationData]);
                    
                    if(l == 1){
                        console.log('Set view');
                        console.log(locationData);
                        const firstViewCoords = [locationData.lat, locationData.lng];
                        map.setView(firstViewCoords, initialZoom);
                    }
                }

               
                
                // Add missing lat and lng to the HTML
                // const location = document.querySelector();
                // location.setAttribute();
                // location.setAttribute();
                //-----------------------------------
            })
            .finally(() => {
              setTimeout(geocodeNext, 1000);
            });

            // Loop
            l++;
        }
        geocodeNext();
    
        console.log('ALL LOCATIONS');
        console.log(allLocations);
        // const location = document.querySelector();
        // location.setAttribute();
        // location.setAttribute();
        
        
        
    }

    // Create fitler functionality
    function retailerFilter(){
        const allRetailerSections = document.querySelectorAll('.leaflet-maps-section');
        
        if(allRetailerSections.length > 0){
            allRetailerSections.forEach(function(section, index){
                const retailerKey = section.getAttribute('data-section-key');
    
            })
        }
    }

    
    

}); // End document load function

/**
 * 
 * @param {*} ip 
 */
function userCountryLatLng(ip) {
    const accessKey = 'f1c664dbb5d87e06b3a26bffd257cc2d';
    fetch(`https://api.ipapi.com/api/${ip}?access_key=${accessKey}`)
    .then(response => response.json())
    .then(data => {
        console.log('User IP:', data.ip);
        console.log('Country:', data.country_name);
        console.log('Region:', data.region_name);
        console.log('Latitude:', data.latitude);
        console.log('Longitude:', data.longitude);
    })
    .catch(error => console.error('Error:', error));
}

/**
     * 
     * @param {*} countryName 
     */
function getCapitalCity(countryName) {
    if(countryName){
        fetch(`https://restcountries.com/v3.1/name/${countryName}`)
        .then(response => response.json())
        .then(data => {
            const capital = data[0].capital[0];
            console.log(`Capital of ${countryCode}:`, capital);
        })
        .catch(error => console.error('Error fetching country info:', error));
    }else{
        console.log('cant get country name');
    }
}

// function userCountryLatLng(ip){
//     fetch(`http://ip-api.com/json/#${ip}`)
//     .then(response => response.json())
//     .then(data => {
//         console.log('Free API data: ',data);
//         console.log('User IP:', data.query);
//         console.log('Country:', data.country);
//         console.log('Capital:', data.city);
//     })
//     .catch(error => console.error('Error:', error));
  
// }



// Sort the store list by distance
function sortStoresListByLocation(mapInstance) {

    console.log("[INFO] sortStoresListByLocation");
    let storesList = [];
    $(".store-locator-maplist-item").each(function(i, item) {
        storesList.push(item);
    });

    storesList.sort(function(a, b) {
    var aDist = parseFloat($(a).find('p span').text()) || 999999;
    var bDist = parseFloat($(b).find('p span').text()) || 999999;
    return aDist - bDist;
    });

    if (storesList.length) {
        
        // Re-append them in the new order
        $('.store-locator-maplist').empty().append(storesList);

        // Optionally center map on the first item
        let firstLat = $(storesList[0]).data("latitude");
        let firstLng = $(storesList[0]).data("longitude");
        if (firstLat && firstLng) {
            mapInstance.setView([firstLat, firstLng], mapInstance.getZoom());
        }
    }
}

function panToLocation(block_id) {
    var lat = $("#info" + block_id + " .store-item__distance").data("latitude");
    var lng = $("#info" + block_id + " .store-item__distance").data("longitude");
    if(lat && lng) {
      if($(window).width() <= 768){
        $(".store-locator-maplist-wrap").hide();
        $(".store-locator-map").removeClass("hidden-on-mobile");

        $(".toggle-icon-map").removeClass("show");
        $(".toggle-icon-list").addClass("show");
      }
      map.setView([lat, lng], 15);
      $(".store-locator-maplist .store-locator-maplist-item").removeClass("lid-selected");
      $("#lid" + block_id).addClass("lid-selected");
      $(".store-locator-map .store-locator-maplist-item").remove();
    }
}

/**
 * 
 * @param {*} element 
 */
function toggle_map(element) {
    var className = element.className;
    element.classList.remove("show");
    var remove_maplist = document.querySelectorAll('.remove-maplist-item');
    
    if(className.includes("toggle-icon-map")) {
      $(".toggle-icon-list").addClass("show");
      $(".store-locator-maplist-wrap").hide();
      $(".store-locator-map").removeClass("hidden-on-mobile");
    } else if(className.includes("toggle-icon-list")) {
      $(".toggle-icon-map").addClass("show");
      $(".store-locator-maplist-wrap").show();
      $(".store-locator-map").addClass("hidden-on-mobile");
      remove_maplist.forEach(item => {
        item.style.display = "none";
      });
    }
}

window.addEventListener('load', function(e){
    console.log('----- window load -----');
    const ip = (this.navigator.ip) ? this.navigator.ip : '194.182.37.4';
    console.log('USED IP: ', ip);
    userCountryLatLng(ip);


    const allRetailerSections = document.querySelectorAll('.leaflet-maps-section');
    const theMap = document.getElementById('map');
    const listContainer = document.querySelector('.map-list-container');
    const mapContainer = document.querySelector('.map-container');
    if(allRetailerSections.length > 0){
        allRetailerSections.forEach(function(section, index){
            //const retailerKey = section.getAttribute('data-section-key');
            listContainer.appendChild(section);

        })

    } 
    if(theMap){
        if(mapContainer){
            mapContainer.appendChild(theMap);
        }
        sortStoresListByLocation(theMap);
    }
    //getCapitalCity();
})